// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"501":"TableData","745":"EditableTable"}[chunkId] || chunkId) + "." + {"22":"31a58749","501":"7b8e19ae","745":"c5285f77"}[chunkId] + ".css";
};